import { render, staticRenderFns } from "./zaiweixiangqing.vue?vue&type=template&id=68153fb7&scoped=true"
import script from "./zaiweixiangqing.vue?vue&type=script&lang=js"
export * from "./zaiweixiangqing.vue?vue&type=script&lang=js"
import style0 from "./zaiweixiangqing.vue?vue&type=style&index=0&id=68153fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68153fb7",
  null
  
)

export default component.exports